import ReactDOM from 'react-dom/client'
import { PortalProviders } from '@portals/shared/PortalProviders'
import { SellerPortal } from '@portals/seller/SellerPortal'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <PortalProviders portal="seller">
    <SellerPortal />
  </PortalProviders>
)
